import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { GroupMember, MotesPaths } from '../../models';

@Component({
    selector: 'group-member-state-indicator',
    templateUrl: './group-member-state-indicator.component.html',
    styleUrls: ['./group-member-state-indicator.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class GroupMemberStateIndicatorComponent implements OnInit {

    // Expose `MotesPaths` to template
    public MotesPaths = MotesPaths;

    /** The `GroupMember` */
    @Input() member: GroupMember = null;
    /** Flag to determine whether to reflect the group members state or simply display a profile picture. */
    @Input() enabled: boolean = false;

    constructor() { }

    ngOnInit(): void {
    }

}
